import { defineRecipe } from '@chakra-ui/react';
import { inputFieldBase, inputFieldSizes, inputFieldVariants } from './Input';
import { Space } from '../../types';

// Single-part recipe reusing the shared input field base / sizes / variants.
export const textareaRecipe = defineRecipe({
  base: {
    ...inputFieldBase,
    minH: Space.SPACE_28,
    verticalAlign: 'top',
    paddingStart: Space.SPACE_3,
    paddingEnd: Space.SPACE_3,
  },
  variants: {
    variant: inputFieldVariants,
    size: inputFieldSizes,
  },
  defaultVariants: {
    size: 'md',
    variant: 'outline',
  },
});
